<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="calculadora-matriculacion">
        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-3">Calcular el impuesto de matriculación (modelo 576)</h1>
                <p class="mb-8 intro-iedmt">
                  Si traes un coche de Alemania, Francia o cualquier otro país de la Unión
                  Europea, antes de matricularlo en España tendrás que liquidar el Impuesto
                  Especial sobre Determinados Medios de Transporte. Calcula aquí cuánto te
                  va a costar: Hacienda no parte del precio que has pagado, sino del valor
                  fiscal del BOE ajustado por la antigüedad del vehículo y por sus emisiones
                  de CO2. En Gestoría Riola confirmamos el valor, presentamos el modelo 576
                  y tramitamos la matriculación completa por ti.
                </p>

                <calculadora-matriculacion
                  :formspree-endpoint="'https://formspree.io/f/mlgqpqkw'"
                  idioma="es"
                />
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import MenuTop from "@/components/MenuTopEsp";
  import MenuBottom from "@/components/MenuBottomEsp";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterEsp";
  import CalculadoraMatriculacion from "@/components/CalculadoraMatriculacion";

  export default {
    name: 'PageCalculadoraMatriculacionEsp',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom,
      CalculadoraMatriculacion
    }
  }
</script>

<style scoped>
  .intro-iedmt {
    color: #37454A;
    max-width: 760px;
  }
  #calculadora-matriculacion h1 {
    color: #900A30;
  }
</style>
